import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import { getFeatured } from "../../store/home/homeAction";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { baseUrl } from "../../utils/APi";
import { LazyLoadImage } from "react-lazy-load-image-component";
import img1 from "../../assets/main/1.jpg";
import img2 from "../../assets/main/2.jpg";
import img3 from "../../assets/main/3.jpg";
import img4 from "../../assets/main/4.jpg";
import img5 from "../../assets/main/5.jpg";
import img6 from "../../assets/main/6.jpg";
import img7 from "../../assets/main/7.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

const LstProjects = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { featured, loading } = useSelector((state) => state.homeSlicer);
  const lan = useSelector((state) => state.LanSlicer.language);
  const swiperRef = useRef(null);

  return (
    <section className="flat-working-project">
      <div className="container-fluid">
        <div className="row">
          <div className="section-title wow fadeInDown">
            <h4 className="section-subtitle">Awesome Works.</h4>
            <h2 className="section-title section-45px-montserrat">
              My Latest Working
              <br />
              Projects
            </h2>
          </div>
          <div className="col-md-12">
            <div className="swiper-container swiper-coverflow style-coverflow ">
              <Swiper
                ref={swiperRef}
                modules={[Navigation, Autoplay, EffectCoverflow]}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                }}
                loop={true}
                centeredSlides={true}
                slidesPerView={1}
                spaceBetween={90}
                grabCursor={true}
                effect="coverflow"
                coverflowEffect={{
                  rotate: 20,
                  stretch: 0,
                  depth: 250,
                  modifier: 1,
                  slideShadows: true,
                }}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                breakpoints={{
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 90,
                  },
                  1024: {
                    slidesPerView: 4,
                    spaceBetween: 90,
                  },
                }}
                className="mySwiper d-flex justify-content-center"
              >
                <SwiperSlide className="new-slider">
                  <img src={img2} alt="Project" />
                  <div className="coverflow-overlay">
                    <div className="coverflow-overlay-content text-white link-style-5">
                      <a
                        href="service-single.html"
                        className="icon-slider-coverflow margin-bottom-30"
                      ></a>
                      <a
                        href="service-single.html"
                        className="section-24px-montserrat"
                      >
                        Company Branding
                      </a>
                      <p className="margin-top-14">Creative Photography</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className="new-slider">
                  <img src={img3} alt="Project" />
                  <div className="coverflow-overlay">
                    <div className="coverflow-overlay-content text-white link-style-5">
                      <a
                        href="service-single.html"
                        className="icon-slider-coverflow margin-bottom-30"
                      ></a>
                      <a
                        href="service-single.html"
                        className="section-24px-montserrat"
                      >
                        Company Branding
                      </a>
                      <p className="margin-top-14">Creative Photography</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className="new-slider">
                  <img src={img4} alt="Project" />
                  <div className="coverflow-overlay">
                    <div className="coverflow-overlay-content text-white link-style-5">
                      <a
                        href="service-single.html"
                        className="icon-slider-coverflow margin-bottom-30"
                      ></a>
                      <a
                        href="service-single.html"
                        className="section-24px-montserrat"
                      >
                        Company Branding
                      </a>
                      <p className="margin-top-14">Creative Photography</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className="new-slider">
                  <img src={img5} alt="Project" />
                  <div className="coverflow-overlay">
                    <div className="coverflow-overlay-content text-white link-style-5">
                      <a
                        href="service-single.html"
                        className="icon-slider-coverflow margin-bottom-30"
                      ></a>
                      <a
                        href="service-single.html"
                        className="section-24px-montserrat"
                      >
                        Company Branding
                      </a>
                      <p className="margin-top-14">Creative Photography</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide className="new-slider">
                  <img src={img1} alt="Project" />
                  <div className="coverflow-overlay">
                    <div className="coverflow-overlay-content text-white link-style-5">
                      <a
                        href="service-single.html"
                        className="icon-slider-coverflow margin-bottom-30"
                      ></a>
                      <a
                        href="service-single.html"
                        className="section-24px-montserrat"
                      >
                        Company Branding
                      </a>
                      <p className="margin-top-14">Creative Photography</p>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
              <div className="swiper-button-next slider-coverflow-btn"></div>
              <div className="swiper-button-prev slider-coverflow-btn"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LstProjects;
